
import { history, ua } from "@weapp/utils";
import { SystemWMSetting } from "./types";
import { watermarkSDK } from './index';

// 系统水印设置
class WatermarkSetting {

  /* 路由取消监听函数 */
  unlistener: (() => void) | null = null;
  
  constructor () {
    this.loadSystemWatermark();
  }

  // 获取全局配置
  getGlobalConfig = () => {
    return window?.TEAMS?.globalConfig;
  }

  // 获取系统水印配置
  getSystemSetting = () => {
    let wmSetting = this.getGlobalConfig();
    if (wmSetting) {
      wmSetting = watermarkSDK.formatWMSetting(wmSetting);
    }
    return wmSetting;
  }

  // 清除水印
  destory = () => {
    watermarkSDK.clear();
  };

  /* 设置水印 */
  setWMOptions = (wmSetting?: SystemWMSetting) => {
    if (!wmSetting) return ;
    const options = watermarkSDK.formatWMSetting(wmSetting);
    // 根据配置初始化水印
    watermarkSDK.set(options);
  }

  // 加载系统水印
  loadSystemWatermark = () => {
    const wmSetting = this.getGlobalConfig();
    if (!wmSetting) {
      this.destory();
      return;
    }
    // 处理水印黑白名单规则
    const pathname = window.location.pathname || "";
    const hash = window.location.hash || "";
    let index = hash.indexOf("?");
    index = index !== -1 ? index : hash.length - 1;
    const href = pathname + hash.substring(0, index);
    if (wmSetting) {
      const { wmUse, wmUseMobile, whitelist, blacklist } = wmSetting;
      const isMobile = ua.device === 'Mobile';
      const isOpen = (isMobile ? wmUseMobile : wmUse) === '1';
      const list: string[] = (isOpen ? blacklist : whitelist) || [];
      try {
        const match = list.findIndex(value => new RegExp(value).test(href));
        if (match !== -1) {
          isOpen
            ? this.destory()
            : this.setWMOptions(wmSetting);
        } else {
          isOpen
            ? this.setWMOptions(wmSetting)
            : this.destory();
        }
      } catch(e) {
        console?.error(e);
      }
    }
  }

  // 监听路由变化
  listenRouteChange = () => {
    this.unlistener = history.listen(() => {
      this.loadSystemWatermark();
    });
  }
}

let systemWatermarkSetting: WatermarkSetting;
try {
  // 加载系统设置水印
  systemWatermarkSetting = new WatermarkSetting();
} catch (error) {
  console?.error(error);
}

export { systemWatermarkSetting };

export default WatermarkSetting;